(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-multi-block"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // 对单个 FAQ section 初始化
    function initFaqSection(root) {
      if (!root) return;

      var searchInput = root.querySelector(".faq-search__input");
      var items = Array.prototype.slice.call(
        root.querySelectorAll(".faq-item")
      );
      var headings = Array.prototype.slice.call(
        root.querySelectorAll(".faq-type-heading")
      );
      var detailEls = Array.prototype.slice.call(
        root.querySelectorAll(".faq-item__details")
      );

      if (!detailEls.length) return;

      /* --- 手风琴：同一个 section 中，只能展开一个 FAQ --- */
      detailEls.forEach(function(detailsEl) {
        detailsEl.addEventListener("toggle", function() {
          // 只有当前这个被打开时才处理
          if (!detailsEl.open) return;

          detailEls.forEach(function(other) {
            if (other !== detailsEl && other.open) {
              other.open = false;
            }
          });
        });
      });

      /* --- 搜索过滤 --- */
      if (searchInput) {
        searchInput.addEventListener("input", function(e) {
          var query = (e.target.value || "").toLowerCase().trim();

          // 1）过滤每个 FAQ item
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var qEl = item.querySelector(".faq-item__question-text");
            var aEl = item.querySelector(".faq-item__answer");
            var text = "";

            if (qEl) text += qEl.textContent + " ";
            if (aEl) text += aEl.textContent + " ";

            text = text.toLowerCase();
            var match = !query || text.indexOf(query) > -1;

            if (match) {
              item.classList.remove("is-hidden");
            } else {
              item.classList.add("is-hidden");
            }
          }

          // 2）根据可见条目控制分类标题的显示/隐藏
          for (var h = 0; h < headings.length; h++) {
            var heading = headings[h];
            var type = heading.getAttribute("data-faq-type") || "";
            var hasVisible = false;

            for (var j = 0; j < items.length; j++) {
              var item2 = items[j];
              if (
                (item2.getAttribute("data-faq-type") || "") === type &&
                !item2.classList.contains("is-hidden")
              ) {
                hasVisible = true;
                break;
              }
            }

            if (hasVisible) {
              heading.classList.remove("is-hidden");
            } else {
              heading.classList.add("is-hidden");
            }
          }
        });
      }
    }

    // 页面首次加载：初始化所有 .faq-section
    document.addEventListener("DOMContentLoaded", function() {
      var sections = document.querySelectorAll(".faq-section");
      for (var i = 0; i < sections.length; i++) {
        initFaqSection(sections[i]);
      }
    });

    // 主题编辑器中，某个 section 被重新加载
    document.addEventListener("shopify:section:load", function(event) {
      var root = event.target.querySelector(".faq-section");
      if (root) {
        initFaqSection(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const faqItems = document.querySelectorAll('.faq-item');
  
  faqItems.forEach(function(item) {
    const question = item.querySelector('.faq-question');
    
    question.addEventListener('click', function() {
      item.classList.toggle('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
